export default __webpack_public_path__ + "static/how-it-works-phase-2-3d3a49d85dfa8a2b620688aebedc1c3d.svg";